/**
 * YT Compare – Modal-based spec comparison.
 * Checkboxes on yt-collection-products cards → sticky bar → modal with table.
 */
(function () {
  var MAX_COMPARE = 4;
  var selectedIds = [];

  /* ── Elements ── */
  var stickyBar = document.querySelector('.yt-compare__sticky-bar');
  var modal = document.querySelector('[data-yt-compare-modal]');
  if (!modal) return;

  var tableContainer = modal.querySelector('[data-compare-table]');
  var highlightDiffs = modal.dataset.highlightDiffs === 'true';

  var specsDataEl = document.querySelector('[data-compare-specs]');
  var allProducts = [];
  try { allProducts = JSON.parse(specsDataEl.textContent); } catch (e) { /* */ }

  var whitelistEl = document.querySelector('[data-compare-whitelist]');
  var whitelist = [];
  try { whitelist = JSON.parse(whitelistEl.textContent); } catch (e) { /* */ }

  var translationsEl = document.querySelector('[data-compare-translations]');
  var t = { sale_price: 'Sale price', compare_price: 'Original price', differs: 'Differs:' };
  try { Object.assign(t, JSON.parse(translationsEl.textContent)); } catch (e) { /* */ }

  /* ── Helpers ── */
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function parseSpecs(product) {
    if (!product.specs) return [];
    if (Array.isArray(product.specs)) return product.specs;
    if (typeof product.specs === 'string') {
      try { return JSON.parse(product.specs); } catch (e) { return []; }
    }
    return [];
  }

  function findSpecValue(product, label) {
    var specs = parseSpecs(product);
    for (var c = 0; c < specs.length; c++) {
      var cat = specs[c];
      if (!cat.rows) continue;
      for (var r = 0; r < cat.rows.length; r++) {
        if (cat.rows[r].label === label) {
          var row = cat.rows[r];
          if (row.value) return row.value;
          if (row.values && typeof row.values === 'object') {
            var parts = [];
            Object.keys(row.values).forEach(function (k) {
              parts.push(k.toUpperCase() + ': ' + row.values[k]);
            });
            return parts.join(' / ');
          }
          return '';
        }
      }
    }
    return '';
  }

  /* ── Sticky Bar ── */
  function updateStickyBar() {
    if (!stickyBar) return;
    stickyBar.hidden = selectedIds.length < 1;
    var countEl = stickyBar.querySelector('.yt-compare__count strong');
    if (countEl) countEl.textContent = String(selectedIds.length);
    var viewBtn = stickyBar.querySelector('.yt-compare__view-btn');
    if (viewBtn) viewBtn.disabled = selectedIds.length < 2;
  }

  /* ── Checkbox handling ── */
  document.addEventListener('change', function (e) {
    var check = e.target.closest('[data-compare-check]');
    if (!check) return;
    var input = check.querySelector('input[type="checkbox"]');
    if (!input) return;
    var id = String(check.dataset.compareProduct);

    if (input.checked) {
      if (selectedIds.length >= MAX_COMPARE) {
        input.checked = false;
        return;
      }
      if (selectedIds.indexOf(id) === -1) selectedIds.push(id);
    } else {
      selectedIds = selectedIds.filter(function (x) { return x !== id; });
    }

    updateCheckboxStates();
    updateStickyBar();
  });

  function updateCheckboxStates() {
    document.querySelectorAll('[data-compare-check]').forEach(function (label) {
      var input = label.querySelector('input[type="checkbox"]');
      if (!input) return;
      var id = String(label.dataset.compareProduct);
      var isSelected = selectedIds.indexOf(id) !== -1;
      if (!isSelected && selectedIds.length >= MAX_COMPARE) {
        input.disabled = true;
        label.classList.add('is-disabled');
      } else {
        input.disabled = false;
        label.classList.remove('is-disabled');
      }
    });
  }

  /* ── Sticky bar buttons ── */
  if (stickyBar) {
    stickyBar.addEventListener('click', function (e) {
      if (e.target.closest('.yt-compare__view-btn')) {
        if (selectedIds.length >= 2) openModal();
      }
      if (e.target.closest('.yt-compare__clear-btn')) {
        selectedIds = [];
        document.querySelectorAll('[data-compare-check] input[type="checkbox"]').forEach(function (cb) {
          cb.checked = false;
          cb.disabled = false;
        });
        document.querySelectorAll('[data-compare-check]').forEach(function (l) {
          l.classList.remove('is-disabled');
        });
        updateStickyBar();
        closeModal();
      }
    });
  }

  /* ── Modal open/close ── */
  var modalTriggerEl = null;

  function openModal() {
    renderTable(selectedIds);

    /* Scale modal width based on number of products: 2→60vw, 3→70vw, 4→80vw */
    var count = selectedIds.length;
    var widths = { 2: '60vw', 3: '70vw', 4: '80vw' };
    modal.style.setProperty('--yt-cmp-modal-width', widths[count] || '80vw');

    /* Remember the element that triggered the modal so we can restore focus
       when it closes (WCAG 2.4.3). */
    modalTriggerEl = document.activeElement;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    document.addEventListener('keyup', onEscape);
    document.addEventListener('keydown', onModalKeydown);

    /* Move focus into the modal — close button is a sensible first stop. */
    var closeBtn = modal.querySelector('[data-compare-modal-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('keyup', onEscape);
    document.removeEventListener('keydown', onModalKeydown);
    if (modalTriggerEl && typeof modalTriggerEl.focus === 'function') {
      modalTriggerEl.focus();
    }
    modalTriggerEl = null;
  }

  function onEscape(e) {
    if (e.key === 'Escape') closeModal();
  }

  /* Tab focus trap (WCAG 2.1.2): keep keyboard focus inside the modal. */
  function onModalKeydown(e) {
    if (e.key !== 'Tab' || !modal.classList.contains('is-open')) return;
    var focusables = modal.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    var visible = Array.prototype.filter.call(focusables, function (el) {
      return el.offsetParent !== null;
    });
    if (!visible.length) return;
    var first = visible[0];
    var last = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  /* Close button + overlay */
  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-compare-modal-close]')) {
      closeModal();
    }
  });

  /* ── Table Rendering ── */
  function renderTable(productIds) {
    if (!tableContainer) return;
    if (productIds.length < 2) {
      tableContainer.innerHTML = '<p class="yt-compare__empty">Select at least 2 models to compare</p>';
      return;
    }

    var products = productIds.map(function (id) {
      return allProducts.find(function (p) { return String(p.id) === String(id); });
    }).filter(Boolean);

    if (products.length < 2) {
      tableContainer.innerHTML = '<p class="yt-compare__empty">Select at least 2 models to compare</p>';
      return;
    }

    var html = '<div class="yt-compare__table-wrap"><table class="yt-compare__table">';

    /* Header: product images + names */
    html += '<thead><tr><th class="yt-compare__th yt-compare__th--label"></th>';
    products.forEach(function (p) {
      html += '<th class="yt-compare__th yt-compare__th--product">';
      if (p.image) {
        html += '<img class="yt-compare__product-img" src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">';
      }
      html += '<span class="yt-compare__product-name">' + escapeHtml(p.title) + '</span>';
      if (p.price_formatted) {
        if (p.compare_at_formatted) {
          html += '<span class="yt-compare__product-price">';
          html += '<span class="visually-hidden">' + escapeHtml(t.sale_price) + ': </span>';
          html += '<span class="yt-compare__product-price-sale">' + escapeHtml(p.price_formatted) + '</span>';
          html += '<span class="visually-hidden">' + escapeHtml(t.compare_price) + ': </span>';
          html += '<s class="yt-compare__product-price-compare">' + escapeHtml(p.compare_at_formatted) + '</s>';
          html += '</span>';
        } else {
          html += '<span class="yt-compare__product-price">' + escapeHtml(p.price_formatted) + '</span>';
        }
      }
      html += '</th>';
    });
    html += '</tr></thead>';

    /* Spec rows */
    html += '<tbody>';
    whitelist.forEach(function (label) {
      var values = products.map(function (p) { return findSpecValue(p, label); });
      var allSame = values.every(function (v) { return v === values[0]; });
      var rowClass = 'yt-compare__row';
      if (highlightDiffs && !allSame && values.some(function (v) { return v !== ''; })) {
        rowClass += ' yt-compare__row--diff';
      }
      var isDiff = highlightDiffs && !allSame && values.some(function (v) { return v !== ''; });
      html += '<tr class="' + rowClass + '">';
      html += '<td class="yt-compare__td yt-compare__td--label">';
      if (isDiff) html += '<span class="visually-hidden">' + escapeHtml(t.differs) + ' </span>';
      html += escapeHtml(label) + '</td>';
      values.forEach(function (v) {
        html += '<td class="yt-compare__td">' + escapeHtml(v || '—') + '</td>';
      });
      html += '</tr>';
    });
    html += '</tbody></table></div>';

    tableContainer.innerHTML = html;
  }
})();
